// extracted by mini-css-extract-plugin
export default {"Close":"SelectedCards_Close__FzubH","Entry":"SelectedCards_Entry__WmtNP","Padding":"SelectedCards_Padding__I8mb0","Switch":"SelectedCards_Switch__ZbSr8"};